const NBH_EMPTY_CART = {
  starterUrl: '/products/snoren-startpakke-med-dansk-flag-excl-hulsten',
  shopUrl: '/collections/all',
  imageUrl: 'https://cdn.shopify.com/s/files/1/1085/3030/3301/files/IMG_20200830_092335_181.jpg?v=1788453026',
};

const NBH_EMPTY_CART_STYLES = `
  cart-drawer.is-empty .nbh-cart-drawer .drawer__inner {
    position: relative;
    width: 420px;
    max-width: 100vw;
  }

  cart-drawer.is-empty .nbh-cart-drawer .drawer__header {
    position: absolute;
    z-index: 5;
    top: 0;
    right: 0;
    left: 0;
    display: flex !important;
    min-height: 53px;
    align-items: center;
    padding: 0 14px 0 16px;
    border-bottom: 1px solid #eee8e1;
    background: #fff;
  }

  cart-drawer.is-empty .nbh-cart-drawer .drawer__heading {
    display: flex !important;
    align-items: center;
    gap: 6px;
    margin: 0;
    color: #231f1c;
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 12px;
    font-weight: 650;
    line-height: 1.2;
    letter-spacing: 0;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__header-icon {
    display: inline-flex;
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__header-icon svg {
    display: block;
    width: 100%;
    height: 100%;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.55;
  }

  cart-drawer.is-empty .nbh-cart-drawer .drawer__close {
    top: 5px;
    right: 5px;
    width: 42px;
    min-width: 42px;
    height: 42px;
    min-height: 42px;
  }

  cart-drawer.is-empty .nbh-cart-drawer .drawer__inner-empty {
    display: block !important;
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 0 !important;
    background: #fff;
  }

  cart-drawer.is-empty .nbh-cart-drawer .cart-drawer__warnings {
    display: block !important;
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 0 !important;
  }

  cart-drawer.is-empty .nbh-cart-drawer .cart-drawer__empty-content {
    display: flex !important;
    width: 100%;
    max-width: none;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: 0 !important;
    padding: 101px 16px 40px;
    text-align: center;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__visual {
    display: grid;
    width: 130px;
    height: 130px;
    overflow: hidden;
    place-items: center;
    border: 1px solid #eee8e1;
    border-radius: 16px;
    background: #f7f8f5;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__title {
    margin: 16px 0 7.5px;
    color: #231f1c;
    font-family: 'Fraunces', Georgia, serif;
    font-size: 17.25px;
    font-weight: 550;
    line-height: 1.2;
    letter-spacing: -.015em;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__text {
    max-width: 320px;
    margin: 0;
    color: #817970;
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 11.7px;
    font-weight: 400;
    line-height: 1.5;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 18px;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button {
    display: inline-flex;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    padding: 12.75px 21px;
    border: 1px solid #ded6ce;
    border-radius: 999px;
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 13.5px;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition: transform .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button--primary {
    min-width: 121px;
    border-color: #231f1c;
    background: #231f1c;
    color: #fff;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button--secondary {
    min-width: 83px;
    background: #fff;
    color: #231f1c;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button:hover {
    transform: translateY(-1px);
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button--primary:hover {
    opacity: .93;
  }

  cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__button--secondary:hover {
    border-color: #231f1c;
    background: #faf7f2;
  }

  cart-drawer.is-empty .nbh-cart-drawer cart-drawer-items,
  cart-drawer.is-empty .nbh-cart-drawer .cart-drawer__collection,
  cart-drawer.is-empty .nbh-cart-drawer .drawer__footer {
    display: none !important;
  }

  @media (max-width: 480px) {
    cart-drawer.is-empty .nbh-cart-drawer .drawer__inner {
      width: 100vw;
    }

    cart-drawer.is-empty .nbh-cart-drawer .cart-drawer__empty-content {
      padding-top: 96px;
    }
  }

  @media (max-height: 620px) {
    cart-drawer.is-empty .nbh-cart-drawer .cart-drawer__empty-content {
      padding-top: 82px;
    }

    cart-drawer.is-empty .nbh-cart-drawer .nbh-cart-empty__visual {
      width: 110px;
      height: 110px;
    }
  }
`;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.onDrawerClick = (event) => {
      if (event.target.closest?.('#CartDrawer-Overlay')) this.close();
    };
    this.addEventListener('click', this.onDrawerClick);

    this.setHeaderCartIconAccessibility();
    this.setCustomHeaderCartAccessibility();
    this.injectEmptyCartStyles();
    this.enhanceEmptyState();

    this.emptyStateObserver = new MutationObserver(() => this.enhanceEmptyState());
    this.emptyStateObserver.observe(this, { childList: true, subtree: true });

    this.onCustomCartOpenClick = (event) => {
      const cartLink = event.target.closest?.('[data-nbh-cart-open]');
      if (!cartLink) return;

      event.preventDefault();
      this.open(cartLink);
    };

    this.onCustomCartOpenKeydown = (event) => {
      const cartLink = event.target.closest?.('[data-nbh-cart-open]');
      if (!cartLink || event.code.toUpperCase() !== 'SPACE') return;

      event.preventDefault();
      this.open(cartLink);
    };

    document.addEventListener('click', this.onCustomCartOpenClick);
    document.addEventListener('keydown', this.onCustomCartOpenKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onDrawerClick);
    document.removeEventListener('click', this.onCustomCartOpenClick);
    document.removeEventListener('keydown', this.onCustomCartOpenKeydown);
    this.emptyStateObserver?.disconnect();
  }

  injectEmptyCartStyles() {
    if (document.getElementById('NbhEmptyCartStyles')) return;

    const style = document.createElement('style');
    style.id = 'NbhEmptyCartStyles';
    style.textContent = NBH_EMPTY_CART_STYLES;
    document.head.appendChild(style);
  }

  enhanceEmptyState() {
    if (!this.classList.contains('is-empty')) return;

    const content = this.querySelector('.cart-drawer__empty-content');
    if (!content || content.dataset.nbhEmptyReady === 'true') return;

    content.dataset.nbhEmptyReady = 'true';

    const heading = this.querySelector('.drawer__heading');
    if (heading && !heading.querySelector('.nbh-cart-empty__header-icon')) {
      heading.innerHTML = `
        <span class="nbh-cart-empty__header-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M6.5 8.5h11l1 11h-13l1-11Z"></path>
            <path d="M9 9V6.8a3 3 0 0 1 6 0V9"></path>
          </svg>
        </span>
        <span>Din kurv</span>
      `;
    }

    const emptyCart = {
      starterUrl: this.dataset.nbhEmptyStarterUrl || NBH_EMPTY_CART.starterUrl,
      shopUrl: this.dataset.nbhEmptyShopUrl || NBH_EMPTY_CART.shopUrl,
      imageUrl: this.dataset.nbhEmptyImageUrl || NBH_EMPTY_CART.imageUrl,
    };

    content.innerHTML = `
      <div class="nbh-cart-empty__visual" aria-hidden="true">
        <img
          class="nbh-cart-empty__image"
          src="${emptyCart.imageUrl}"
          alt=""
          loading="eager"
          width="260"
          height="260"
        >
      </div>
      <h2 class="nbh-cart-empty__title">Kurven er tom</h2>
      <p class="nbh-cart-empty__text">Start med en færdig styling — så har du snor, ringe og pynt fra dag ét.</p>
      <div class="nbh-cart-empty__actions">
        <a class="nbh-cart-empty__button nbh-cart-empty__button--primary" href="${emptyCart.starterUrl}">Se startpakken</a>
        <a class="nbh-cart-empty__button nbh-cart-empty__button--secondary" href="${emptyCart.shopUrl}">Shop alt</a>
      </div>
    `;
  }

  setCustomHeaderCartAccessibility() {
    document.querySelectorAll('[data-nbh-cart-open]').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.setAttribute('aria-controls', 'CartDrawer');
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.enhanceEmptyState();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections?.[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.enhanceEmptyState();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return source?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
